import { Input } from '../input'
import Icon from '../icon'
import { KeyCode } from '../../core/KConstants'

export default {
  name: 'KDatePickerInput',
  props: {
    pickerType: {
      type: String,
      default: 'date',
    },
    value: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '选择日期',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      validator: (value) => ['large', 'normal', 'small', 'mini'].indexOf(value) !== -1,
      default: 'normal',
    },
    hidePickerIcon: {
      type: Boolean,
    },
    multiple: {
      type: Boolean,
    },
  },
  data() {
    return {
      focused: false,
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    handleLabelClear(option) {
      this.$emit('action:labelClick', option)
    },
    renderArrow() {
      return (
        <template slot="suffix">
          <Icon
            icon="chevron-down"
            class="km-date-picker__arrow"
          />
        </template>
      )
    },
    handleKeydown(e) {
      const keyCode = e.which
      if (keyCode === KeyCode.TAB) {
        return true
      }
      e.preventDefault()

      this.$emit('action:keydown', keyCode)
    },
    focus() {
      this.$refs.input.focus()
    },
  },
  render() {
    const selectCss = {
      'km-date-picker': true,
      // 'km-select--multiple': this.multiple,
      'is-active': this.active || this.focused,
      'km-date-picker--active': this.active,
      'km-date-multiple-picker': this.multiple,
    }

    const style = {}
    if (this.multiple) {
      style.height = 'auto'
    }

    const events = {
      focus: () => {
        this.focused = true
      },
      blur: () => {
        this.focused = false
      },
      clear: (e) => {
        e && e.stopPropagation()
        this.$emit('clear')
      },
    }

    const nativeEvents = {
      keydown: this.handleKeydown,
    }

    const props = {
      value: this.value,
      clearable: this.clearable,
      clearSuffix: true,
      clearableOnHover: true,
      disabled: this.disabled,
      loading: this.loading,
      size: this.size,
      prefix: (!this.hidePickerIcon || '') && (this.pickerType.indexOf('time') !== -1 ? 'clock' : 'calendar'),
      'original-readonly': true,
      inputClass: 'km-date-picker__label',
    }

    const attrs = {
      placeholder: this.placeholder,
    }

    const data = {
      class: selectCss,
      style: style,
      on: events,
      nativeOn: nativeEvents,
      ref: 'input',
      props: props,
      attrs: attrs,
    }

    const arrow = this.renderArrow()

    return <Input
      {...data}>
      {this.$slots.default}
      {arrow}
    </Input>
  },
}
